export const HISTORY_ACTION_TYPE = {
  PUSH: "PUSH",
  POP: "POP",
} as const;

export type THistoryActionType = keyof typeof HISTORY_ACTION_TYPE;
